// Classifica de onde veio o visitante. Usado no servidor (painel) e no navegador (coletor de visitas).
const HOST_NAMES = [
  [/google./, 'Google (busca)'], [/bing./, 'Bing'], [/instagram.|l.instagram/, 'Instagram'], [/facebook.|fb.|l.facebook/, 'Facebook'],
  [/linkedin.|lnkd.in/, 'LinkedIn'], [/youtube.|youtu.be/, 'YouTube'], [/^t.co$|twitter.|^x.com$/, 'X (Twitter)'],
  [/wa.me|whatsapp|wl.co/, 'WhatsApp'], [/tiktok./, 'TikTok'], [/baseplus./, 'BasePlus'],
];

/** De onde veio o visitante: campanha (UTM), anúncio (gclid/fbclid...), site de origem ou acesso direto. */
export function sourceOf(a) {
  if (!a) return 'Direto';
  if (a.utm_source) return a.utm_medium ? `${a.utm_source} / ${a.utm_medium}` : a.utm_source;
  if (a.gclid) return 'Google Ads';
  if (a.fbclid) return 'Meta Ads';
  if (a.ttclid) return 'TikTok Ads';
  if (a.msclkid) return 'Bing Ads';
  if (a.referrer) {
    try {
      const host = new URL(a.referrer).hostname.replace(/^www./, '');
      const m = HOST_NAMES.find(([re]) => re.test(host));
      return m ? m[1] : host;
    } catch { /* referrer inválido: cai em Direto */ }
  }
  return 'Direto';
}
